import { ShieldX } from "lucide-react";
import { useRouter } from "@/lib/navigation";
import { Button } from "@myela/ui";

/**
 * Shown when an authenticated user (or the user being impersonated) lacks
 * access to a route. A clean in-app screen — not a redirect or a toast — so the
 * denial is explicit and consistent across every restricted page.
 */
export function PermissionDenied() {
  const router = useRouter();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="flex size-14 items-center justify-center rounded-full bg-[var(--negative-50,#fef2f2)] text-[var(--negative-600,#dc2626)]">
        <ShieldX className="size-7" />
      </div>
      <div className="space-y-1.5">
        <h1 className="text-lg font-semibold text-[var(--ink-900)]">
          You don&apos;t have permission to access this page
        </h1>
        <p className="max-w-md text-sm text-[var(--ink-600)]">
          This area is restricted. If you need access, please contact an
          internal administrator.
        </p>
      </div>
      <Button variant="secondary" onClick={() => router.push("/")}>
        Back to Dashboard
      </Button>
    </div>
  );
}
